import React, { useState } from 'react';
import DialogComponent from '../dialog/dialog.component';
import warning from '../../images/profile/warning.png';
import { Checkbox } from 'antd';

interface ConfirmReactPostProps {
  visible: boolean;
  isLike: boolean;
  onConfirm: (suppressDays: number | null) => void;
  onCancel: () => void;
  onClose: () => void;
}

const ConfirmReactPost = ({
  visible,
  isLike,
  onConfirm,
  onCancel,
  onClose,
}: ConfirmReactPostProps) => {
  const [selected, setSelected] = useState<string | null>(null);
  const handleChange = (value: string) => {
    setSelected(selected === value ? null : value);
  };

  const handleConfirm = () => {
    let suppressDays: number | null = null;
    if (selected === '30days') {
      suppressDays = 30;
    } else if (selected === 'forever') {
      suppressDays = -1; 
    }
    onConfirm(suppressDays);
  };
  return (
    <div>
      <DialogComponent
        visible={visible}
        onClose={onClose}
        size="full"
        placement="CENTER"
        title="Chú ý"
        customSize="w-full max-w-[399px] "
      >
        <div className="flex flex-col gap-3 ">
          <div className="flex flex-col justify-center items-center bg-[#F6F7F8]">
            <img src={warning} alt="cảnh báo" />
            <p className="text-[#62677D] dark:text-slate-100 p-6 text-base font-medium">
              Bạn chỉ có thể tương tác bài viết chỉ 1 lần!
            </p>
          </div>
        </div>
        <div className="px-10 pb-4 bg-[#F6F7F8]">
          <Checkbox
            checked={selected === '30days'}
            onChange={() => handleChange('30days')}
          >
            Không hiển thị lại trong 30 ngày
          </Checkbox>

          <Checkbox
            checked={selected === 'forever'}
            onChange={() => handleChange('forever')}
          >
            Không hiển thị lại vĩnh viễn
          </Checkbox>
        </div>
        <div className="flex justify-end gap-2 border-t border-t-[#DEE0E6] dark:border-t-slate-700 p-6">
          <button
            className=" dark:text-slate-50 px-4 py-2 rounded-lg border border-solid border-[#DEE0E6] dark:border-slate-700 text-base text-[#18191E] cursor-pointer font-medium"
            onClick={onCancel}
          >
            Huỷ bỏ
          </button>
          <button
            className="px-4 py-2 rounded-lg bg-[#0057FF] text-white  text-base font-semibold cursor-pointer "
            onClick={handleConfirm}
          >
            Đồng ý
          </button>
        </div>
      </DialogComponent>
    </div>
  );
};

export default ConfirmReactPost;
